import { combineReducers } from 'redux';
import { connectRouter } from 'connected-react-router';
import history from '../history';
import account from './Account';
import accountIntegrations from './accountIntegrations';
import benchmarks from './benchmarks';
import billing from './billing';
import contributors from './Contributors/index';
import { commentHistory } from './CommentHistory';
import { dashboard } from './Dashboard';
import installations from './installations';
import login from './login';
import notes from './notes';
import organizationData from './organizationData';
import organizationMembers from './organizationMembers';
import onprem from './onprem';
import organizations from './organizations';
import projects from './projects';
import { projectDashboard } from './ProjectDashboard';
import projectData from './projectData';
import pullRequests from './pullRequests';
import ratings from './ratings';
import reviews from './reviews';
import reviewRules from './reviewRules';
import signups from './signups';
import theme from './Theme';
import { store as v2 } from 'stores';

export default combineReducers({
  account,
  accountIntegrations,
  benchmarks,
  billing,
  contributors,
  commentHistory,
  dashboard,
  installations,
  login,
  notes,
  organizationData,
  organizationMembers,
  onprem,
  organizations,
  projects,
  projectDashboard,
  projectData,
  pullRequests,
  ratings,
  reviews,
  reviewRules,
  router: connectRouter(history),
  signups,
  theme,

  v2,
});
